(() => {
  const normalize = (value) => value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').trim().replace(/\s+/g, ' ');
  const tagForKind = (kind) => 'naskind' + normalize(kind).replace(/ /g, '') + 'z';
  const colors = ['Gellack', 'Cat Eye Gellack', 'Transparenter Gellack', 'Effekt Glitter Gellack', 'Flash Effekt Gellack', 'Metallic Gellack', 'Pediküre Gellack'];
  const bases = ['Gellack Base', 'Gellack Builder Base', 'Gellack Glitter Builder Base'];
  const rules = [
    {"group":"nasgroupacrylgelz","collection":"aufbaugele/nasgroupacrylgelz","label":"Acrylgel","aliases":["acrylgel","acrylgele","acryl gel","acryl gele","acrygel","acrygele","acrylic gel","acrylic gels","polygel","poly gel","hybridgel","hybridgele","hybrid gel","hybrid gels","acryl aufbaugel","acryl aufbaugele"],"kinds":["Acryl Aufbaugel"]},
    {"group":"nasgroupdesinfektionz","collection":"desinfektion/nasgroupdesinfektionz","label":"Desinfektion","aliases":["desinfektion","desinfektionsmittel","desinfektionslosung","desinfektionsloesung","desinfektionsflussigkeit","desinfektionsfluessigkeit","disinfectant","disinfectants"],"kinds":["Instrumentendesinfektionsmittel","Händedesinfektionsmittel"]},
    {"group":"nasgroupnagelolz","collection":"kosmetik-25/nasgroupnagelolz","label":"Nagelöl","aliases":["nagelol","nagelole","nageloel","nageloele","nagel ol","nagel ole","nagel oel","nagel oele","nagelhautol","nagelhautoel","nagelhaut ol","nagelhaut oel","nail oil","nail oils","cuticle oil","cuticle oils"],"kinds":["Nagelöl","Nagelölstift"]},
    {"group":"nasgroupgellackentfernerz","collection":"arbeitsflussigkeiten/nasgroupgellackentfernerz","label":"Gellack-Entferner","aliases":["gellack entferner","gellackentferner","shellac entferner","shellacentferner","shellack entferner","soak off entferner","soakoff entferner","gel polish remover","gellack remover","gellackremover","shellac remover"],"kinds":["Soak Off Gellack Entferner","Soak Off Liquid"]},
    {"group":"nasgroupcleanerz","collection":"arbeitsflussigkeiten/nasgroupcleanerz","label":"Cleaner","aliases":["cleaner","cleaners","gelcleaner","gel cleaner","nagelcleaner","nagel cleaner","nagelreiniger","nagel reiniger"],"kinds":["Cleaner","Glanz-Cleaner","Cleaner & Raumspray"]},
    {"group":"nasgroupacrylliquidz","collection":"acryl/nasgroupacrylliquidz","label":"Acryl Liquid","aliases":["acryl liquids","acryl liquid","acrylliquids","acrylliquid","acrylic liquids","acrylic liquid","acryl fluessigkeit","acryl flussigkeit","acrylflussigkeit","acrylfluessigkeit"],"kinds":["Acryl Liquid"]},
    {"group":"nasgroupacrylpulverz","collection":"spirits-spi/nasgroupacrylpulverz","label":"Acrylpulver","aliases":["acrylpulver","acryl pulver","acrylpuder","acryl puder","acrylic powder","acrylic powders","acryl powder","acryl powders"],"kinds":["Aufbau Acrylpulver","Neon Acrylpulver Set"]},
    { group: 'nasgroupspezialgelz', collection: 'spezialgele/nasgroupspezialgelz', label: 'Spezialgel', aliases: ['spezialgele', 'spezialgel', 'spezial gele', 'spezial gel', 'special gels', 'special gel'], kinds: ["Plastilingel","Funktionsgellack","Metallic Gellack","Transferfolien Klebegel","Funktionsgel","Steinchen Klebegel"] },
    { group: 'nasgroupglittergelz', collection: 'glittergele/nasgroupglittergelz', label: 'Glittergel', aliases: ['glittergele', 'glittergel', 'glitzergele', 'glitzergel', 'glitter gels', 'glitter gel', 'glitzer gele', 'glitzer gel'], kinds: ["Glitter Painting Gel","Shimmergel","Metallic Effektgel","Glittergel","Chrome Painting Gel","Glittergel mit Perlenschimmer"] },
    { group: 'nasgroupfarbgelz', collection: 'farbgele/nasgroupfarbgelz', label: 'Farbgel', aliases: ['farb und malgele', 'farb und malgel', 'farbgele', 'farbgel', 'farb gele', 'farb gel', 'color gels', 'color gel', 'colour gels', 'colour gel'], kinds: ['Farb- und Malgel'] },
    { group: 'nasgroupversieglerz', collection: 'versieglungsgele/nasgroupversieglerz', label: 'Versiegler', aliases: ['versiegelungsgele', 'versiegelungsgel', 'versieglungsgele', 'versieglungsgel', 'gelversiegler', 'gel versiegler', 'versiegler', 'finishgele', 'finishgel', 'finish gel', 'finish gele', 'topgel', 'top gel', 'top'], kinds: ["Versiegelungsgel mit Schwitzschicht","Versiegelungsgel ohne Schwitzschicht","Milchiges Versiegelungsgel ohne Schwitzschicht","Mattes Versiegelungsgel ohne Schwitzschicht","Effektversiegelungsgel ohne Schwitzschicht"] },
    { group: 'nasgroupaufbaugelz', collection: 'aufbaugele/nasgroupaufbaugelz', label: 'Aufbaugel', aliases: ['aufbaugele', 'aufbaugel', 'aufbau gele', 'aufbau gel'], kinds: ["Thixotropes Aufbaugel","Fiberglas-Aufbaugel","Monophase Aufbaugel","Glitter Aufbaugel","Camouflage Aufbaugel","Fiberglas Aufbaugel","Covergel"] },
    { group: 'nasgroupgellackbasez', label: 'Gellack Base', aliases: ['shellac base', 'shellac basis', 'gellack base', 'gellack basis', 'gel lack base'], kinds: bases },
    { group: 'nasgroupgellacktopz', label: 'Gellack Top', aliases: ['shellac top', 'gellack top'], kinds: ['Gellack Top mit Schwitzschicht', 'Gellack Top ohne Schwitzschicht'] },
    { group: 'nasgrouphaftgelz', label: 'Haftgel', aliases: ['haftgele', 'haftgel', 'bonding gel'], kinds: ['Haftgel mit Keratin', 'Verstärkendes Haftgel', 'Gellack Base'] },
    { group: 'nasgroupgellackfarbez', label: 'Gellack', aliases: ['shellac', 'shellack', 'schellack', 'gellacke', 'gellack', 'gel lack', 'gel polish'], kinds: colors }
  ];
  const scopeForRule = (rule) => 'tag:"' + rule.group + '"';
  const resolve = (value) => {
    const raw = value.trim();
    if (!raw || /[:()"\\]/.test(raw)) return null;
    const normalized = normalize(raw);
    for (const rule of rules) {
      for (const alias of rule.aliases) {
        if (normalized !== alias && !normalized.startsWith(alias + ' ')) continue;
        const remainder = normalized.slice(alias.length).trim();
        const tags = rule.kinds.map(tagForKind);
        const scope = scopeForRule(rule);
        const suffix = remainder ? ' AND ' + remainder.split(' ').map((word) => '"' + word + '"').join(' AND ') : '';
        return { raw, query: scope + suffix, tags, collection: remainder ? null : rule.collection };
      }
    }
    return null;
  };
  const searchPath = (path) => /\/search\/?$/.test(path);
  const displayTerm = () => {
    const url = new URL(location.href);
    const internal = url.searchParams.get('q') || '';
    const original = url.searchParams.get('na_q') || '';
    if (resolve(original)?.query === internal) return original;
    for (const rule of rules) {
      const scope = scopeForRule(rule);
      if (internal === scope) return rule.label;
      if (internal.startsWith(scope + ' AND ')) {
        const suffix = internal.slice(scope.length + 5);
        if (/^"[a-z0-9]+"(?: AND "[a-z0-9]+")*$/.test(suffix)) {
          return rule.label + ' ' + suffix.replace(/"/g, '').replace(/ AND /g, ' ');
        }
      }
    }
    return internal;
  };
  const collectionUrl = (routed, url) => {
    if (!routed?.collection) return null;
    const target = new URL(url.href);
    target.pathname = target.pathname.replace(/\/search\/?$/, '/collections/' + routed.collection);
    target.search = '';
    return target;
  };
  const renderDisplayTerm = () => {
    if (!searchPath(location.pathname)) return;
    const url = new URL(location.href);
    const internal = url.searchParams.get('q') || '';
    const original = displayTerm();
    const routed = resolve(internal);
    const collection = collectionUrl(routed || resolve(original), url);
    if (collection && !url.searchParams.has('na_fallback')) {
      location.replace(collection.href);
      return;
    }
    if (routed && !url.searchParams.has('na_fallback')) {
      url.searchParams.set('q', routed.query);
      url.searchParams.set('na_q', routed.raw);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[unavailable_products]', 'show');
      location.replace(url.href);
      return;
    }
    if (!original || original === internal) return;
    document.querySelectorAll('main input[type="search"][name="q"]').forEach((input) => { input.value = original; });
    const main = document.querySelector('main');
    if (main) {
      const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        if (!node.parentElement.closest('script,style')) node.nodeValue = node.nodeValue.split(internal).join(original);
      });
    }
    document.title = document.title.split(internal).join(original);
  };
  const resultUrl = (form, value) => {
    const url = new URL(form.action, location.href);
    for (const [name, entry] of new FormData(form)) url.searchParams.set(name, entry);
    const routed = resolve(value);
    const collection = collectionUrl(routed, url);
    if (collection) return collection;
    url.searchParams.set('q', routed ? routed.query : value.trim());
    if (routed) {
      url.searchParams.set('na_q', routed.raw);
      url.searchParams.set('type', 'product');
    } else {
      url.searchParams.delete('na_q');
    }
    url.searchParams.set('options[unavailable_products]', 'show');
    url.searchParams.delete('page');
    return url;
  };
  const submit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector('input[type="search"][name="q"]')) return;
    const url = new URL(form.action, location.href);
    if (url.origin !== location.origin || !searchPath(url.pathname)) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!resolve(input.value) || form.querySelector('[aria-selected="true"] a')) return;
    event.preventDefault();
    location.assign(resultUrl(form, input.value).href);
  };
  window.NailartsSearch = Object.freeze({ resolve, tagForKind, displayTerm, resultUrl });
  document.addEventListener('submit', submit, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !searchPath(location.pathname)) return;
    const url = new URL(link.href, location.href);
    const original = displayTerm();
    if (url.origin === location.origin && searchPath(url.pathname) &&
        resolve(original)?.query === url.searchParams.get('q')) {
      url.searchParams.set('na_q', original);
      link.href = url.href;
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderDisplayTerm);
  else renderDisplayTerm();
})();